import jsonp from 'jsonp'
import { customEncodeURI, getCallback } from '@/utils/utils'

const baseURL = 'https://webutils.aws.stthomas.edu/xmltojson.do'

export default {
  getSpaces (query) {
    const urlParam = customEncodeURI(`url=https://feeds.aws.stthomas.edu/r25-aws-bridge/spaces.xml?name=${query}&scope=list`)

    return new Promise((resolve, reject) => {
      const callback = getCallback()

      jsonp(`${baseURL}?${urlParam}`, { name: callback }, (err, data) => {
        if (err) {
          console.error(err.message)
          reject(err.message)
        } else {
          resolve(data)
        }
      })
    })
  },

  getReservations (id, start, end) {
    const urlParam = customEncodeURI(`url=https://feeds.aws.stthomas.edu/r25-aws-bridge/reservations.xml?space_id=${id}&start_dt=${start}&end_dt=${end}&scope=extended&event_state=1+2`)

    return new Promise((resolve, reject) => {
      const callback = getCallback()

      jsonp(`${baseURL}?${urlParam}`, { name: callback }, (err, data) => {
        if (err) {
          console.error(err.message)
          reject(err.message)
        } else {
          resolve(data)
        }
      })
    })
  }
}
